import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import AccountNumberAutoSuggests from '../common/accountNumberAutoSuggestsAvailPricing';

/* Dialogs */
import AddShippingAddressOverlayDialog from '../../dialogs/addShippingAddressOverlayDialog';
import AddAccessoriesDialog from '../../dialogs/addAccessoriesDialog';
import AddServicesOverlayDialog from '../../dialogs/addServicesOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';

/* Actions */
import {
    showAddressVerificationDialog,
    getOrderableServices,
    checkServicePrices,
    getPIMItemInfo,
    createNewOrder,
    saveCreatedPackageDetails,
    getModelsBySalesAgreement,
    ajaxRequestInitiated,
    ajaxRequestCompleted,
    saveOrderableServices,
    checkPricesForSearchResult,
} from '../../../redux/actions';
import { routes } from '../../../redux/api/routes';

const {
	product,
	productAPIUrl,
} = routes;

import {
	sendRequest
} from '../../../redux/api/sendRequest';

class CreatePackage extends Component {

	constructor(props) {
		super(props);
        const { selectedPriceSource, selectedAddress, selectedAccount } = this.props.state.user;
        let agreementNumber = '';
        if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
            agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
        }
        const shippingAddress = selectedAddress ? JSON.parse(selectedAddress) : null;
		this.state = {
            isDataValid : true,
            errorMessage: '',
            createPackageForm: {
                params: {
                    poNumber: '',
                    whichTypeOfCreate: 'iWillEnter',
                    shippingAddress:
                        shippingAddress
                            ? {
                                name: selectedAccount.ORGANIZATIONNAME,
                                address1: shippingAddress.ADDRESS1,
                                address2: "",
                                address3: "",
                                address4: "",
                                city: shippingAddress.CITY,
                                state: shippingAddress.STATE,
                                zip: shippingAddress.POSTALCODE,
                                phone: '',
                                addressId: shippingAddress.SITE_USE_ID,
                                SITEID: shippingAddress.SITEID,
                            }
                            : null
                        ,
                    deliveryMethod: '',
                    items: [{
                        item: '',
                        itemError: '',
                        itemType: 'M',
                        quantity: "1",
                        price: '',
                        productDetails: null,
                        agreementNumber,
                        quantityError: false,
                        agreementNumberError: false
                    }],
                },
                errors: {
                    poNumberError: '',
                    shippingAddressError:''
                }
            },
            showAddShippingAddressOverlayDialog: false,
            showAddAccessoriesDialog: false,
            showAddServicesOverlayDialog: false,
            showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
            shippingAddressList: this.props.getCombinedAddresses().filter(item => item.PURPOSE === 'SHIP_TO'),
		};
        this.setChangeMethod = [];
        this.checkLocTypeAvailable = this.checkLocTypeAvailable.bind(this);
        this.onChangeUpdateParam = this.onChangeUpdateParam.bind(this);
        this.handleDialog = this.handleDialog.bind(this);
        this.handleAddAccessories = this.handleAddAccessories.bind(this);
        this.updateAddress = this.updateAddress.bind(this);
        this.handleCallBackAfterAddedNewAddress = this.handleCallBackAfterAddedNewAddress.bind(this);
        this.getShippingAddressZipCode = this.getShippingAddressZipCode.bind(this);
        this.manageAvailableServices = this.manageAvailableServices.bind(this);
        this.checkIfStateIsAk = this.checkIfStateIsAk.bind(this);
        this.getShippingAddressState = this.getShippingAddressState.bind(this);
        this.onChangeShippingAddress = this.onChangeShippingAddress.bind(this);
        this.fetchQuoteModels = this.fetchQuoteModels.bind(this);
	}

    componentWillMount() {
		const self = this;
        let isPricingAccess = self.props.isResponsibilityExists("Price");
		// redirect user to home page if user has not access to this page
		if(!isPricingAccess) {
			browserHistory.push('/home');
		}
	}

    componentDidMount() {
        this.updateAddress(this.props);
        const myInt = setInterval(() => {
            if (this.state.createPackageForm.params.shippingAddress && this.state.createPackageForm.params.shippingAddress.zip) {
                const address = this.state.createPackageForm.params.shippingAddress;
                this.updateDeliveryAndLocType(address);
                clearInterval(myInt);
            }
        }, 200);
    }

    updateDeliveryAndLocType(address) {
        const self = this;
        const {accountDetail} = self.props.state.user;
        const accNo = accountDetail.responseObject[0].ACCOUNTNUMBER;
        const stateValue = address.STATE ? address.STATE : "";
        const countryValue = address.COUNTRY ? address.COUNTRY : "";
        self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, 'sds_loc', resp => {
            if(self.checkIfStateIsAk()) {
                resp = {
                    agentid: "SEA",
                    dockcity: "SEATTLE"
                }
            }
            if (resp.agentid) {
                self.setState({
                    createPackageForm: {
                        ...self.state.createPackageForm,
                        params: {
                            ...self.state.createPackageForm.params,
                            deliveryMethod: resp.loctype === 'sds_loc' ? 'SDS Delivery' : 'ADC LTL',
                            warehouseCode: resp.agentid
                        }
                    }
                }, () => {
                    if (self.state.createPackageForm.params.deliveryMethod !== 'SDS Delivery') {
                        const { items } = self.state.createPackageForm.params;
                        items.forEach(item => {
                            delete item.relatedServices;
                        });
                        self.setState({
                            createPackageForm: {
                                ...self.state.createPackageForm,
                                params: {
                                    ...self.state.createPackageForm.params,
                                    items,
                                }
                            }
                        });
                    }
                });
            }
        },true,stateValue,accNo,null,false,countryValue);
    }

    componentWillReceiveProps(nextProps) {
        // if user change any SA in header
        if (this.props.state.user.selectedPriceSource.AGREEMENT_NUMBER !== nextProps.state.user.selectedPriceSource.AGREEMENT_NUMBER) {
            const { whichTypeOfCreate } = this.state.createPackageForm.params;
            // if user has already selected quote models
            if (whichTypeOfCreate === 'pickModels') {
                const quoteType = this.props.getAttributeBySalesAgreement(nextProps.state.user.selectedPriceSource.AGREEMENT_NUMBER, 'Quote Type');
                // if new agreement number is quote type Q
                if (quoteType === 'Q' || quoteType === 'M' || quoteType === 'U') {
                    this.onChangeUpdateParam({
                        target: {
                            value: 'pickModels',
                            name: 'whichTypeOfCreate'
                        }
                    });
                }
                // else make iWillEnter selected
                else {
                    this.onChangeUpdateParam({
                        target: {
                            value: 'iWillEnter',
                            name: 'whichTypeOfCreate'
                        }
                    });
                }
            }
        }
        if (!this.state.createPackageForm.params.shippingAddress && nextProps.state.user.selectedAddress) {
            const { selectedAccount } = this.props.state.user;
            const shippingAddress = JSON.parse(nextProps.state.user.selectedAddress);
            this.setState({
                createPackageForm: {
                    ...this.state.createPackageForm,
                    params: {
                        ...this.state.createPackageForm.params,
                        shippingAddress: {
                			name: selectedAccount.ORGANIZATIONNAME,
                			address1: shippingAddress.ADDRESS1,
                			address2: "",
                			address3: "",
                			address4: "",
                			city: shippingAddress.CITY,
                			state: shippingAddress.STATE,
                			zip: shippingAddress.POSTALCODE,
                			phone: '',
                			addressId: shippingAddress.SITE_USE_ID,
                			SITEID: shippingAddress.SITEID,
                		}
                    }
                }
            });
        }
    }

    updateAddress(nextProps) {
        if (!this.state.createPackageForm.params.shippingAddress && nextProps.state.user.selectedAddress) {
            const { selectedAccount } = this.props.state.user;
            const shippingAddress = JSON.parse(nextProps.state.user.selectedAddress);
            this.setState({
                createPackageForm: {
                    ...this.state.createPackageForm,
                    params: {
                        ...this.state.createPackageForm.params,
                        shippingAddress: {
                            name: selectedAccount.ORGANIZATIONNAME,
                            address1: shippingAddress.ADDRESS1,
                            address2: "",
                            address3: "",
                            address4: "",
                            city: shippingAddress.CITY,
                            state: shippingAddress.STATE,
                            zip: shippingAddress.POSTALCODE,
                            phone: '',
                            addressId: shippingAddress.SITE_USE_ID,
                            SITEID: shippingAddress.SITEID,
                        }
                    }
                }
            });
        }
    }

    updateQuickOrderState(itemIndex, productDetails) {
		const self = this;
        const { items } = self.state.createPackageForm.params;
        items.forEach((item, index) => {
            if(index === itemIndex) {
                item.productDetails = productDetails;
                item.item = productDetails.sku;
                item.itemDescription = productDetails.description;
                let netPrice = '';
                if(productDetails.pricingData && productDetails.pricingData.length) {
                    const data = productDetails.pricingData.find(itm => itm.item_number === item.item);
                    if (data && data.records && data.records.length && data.records[0].adjusted_unit_price) {
                        netPrice = data.records[0].adjusted_unit_price;
                    }
                }
                item.checked = true;
                item.price = netPrice;
				delete item.isAddressChanged;
            }
        })
        self.setState({
            createPackageForm: {
                ...this.state.createPackageForm,
                params: {
                    ...this.state.createPackageForm.params,
                    items
                }
            },
            isDataValid: true
        });
    }

    handleChangeProductNumberTextBox(itemIndex, productNumber) {
        const self = this;
        const { items } = self.state.createPackageForm.params;
        items.forEach((item, index) => {
            if(index === itemIndex) {
                item.item = productNumber;
                item.itemError = '';
                if(productNumber === '') {
                    item.productDetails = null
                }
            }
        })
        self.setState({
            createPackageForm: {
                ...this.state.createPackageForm,
                params: {
                    ...this.state.createPackageForm.params,
                    items
                }
            }
        });
    }

    // event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

    onChangeShippingAddress(event) {
        const self = this;
        const { shippingAddressList } = self.state;
        const address = shippingAddressList.find(item => item.ADDRESS1 === event.target.value);
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
    				...self.state.createPackageForm.params,
    				shippingAddress: {
                        name: self.state.createPackageForm.params.shippingAddress.name,
                        address1: address.ADDRESS1,
                        address2: "",
                        address3: "",
                        address4: "",
                        city: address.CITY,
                        state: address.STATE,
                        zip: address.POSTALCODE,
                        phone: '',
                        addressId: address.SITE_USE_ID,
                        SITEID: address.SITEID,
                    }
    			}
            }
        }, () => {
            self.updateDeliveryAndLocType(address);
        });
    }

    onChangeUpdateParam(event) {
        const self = this;
		let { name, value } = event.target;
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
    				...self.state.createPackageForm.params,
    				[name]: value
    			}
            }
        }, () => {
            if (name === 'whichTypeOfCreate') {
                const { AGREEMENT_NUMBER } = self.props.state.user.selectedPriceSource;
                if (value === 'iWillEnter') {
                    self.setState({
                        createPackageForm: {
                            ...self.state.createPackageForm,
                            params: {
                                ...self.state.createPackageForm.params,
                                items: [{
                                    item: '',
                                    itemError: '',
                                    itemType: 'M',
                                    quantity: "1",
                                    price: '',
                                    productDetails: null,
                                    agreementNumber: AGREEMENT_NUMBER,
                                    quantityError: false,
                                    agreementNumberError: false
                                }],
                            }
                        }
                    });
                } else if (value === 'pickModels') {
                    self.setState({
                        createPackageForm: {
                            ...self.state.createPackageForm,
                            params: {
                				...self.state.createPackageForm.params,
                				items: []
                			}
                        }
                    }, () => {
                        self.fetchQuoteModels();
                    });

                }
            }
        });
		if(self.state.createPackageForm.errors[name+"Error"]) {
			self.setState({
                createPackageForm: {
                    ...self.state.createPackageForm,
    				errors: {
    					...self.state.createPackageForm.errors,
    					[name+"Error"]: ""
    				}
                }
	        });
		}
    }

    onChangeUpdateItem(index, event) {
        const self = this;
		let { name, value } = event.target;
        const { items } = self.state.createPackageForm.params;
        items[index][name] = value;
        if (items[index][name+'Error']) {
            items[index][name+'Error'] = '';
        }
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
    				...self.state.createPackageForm.params,
    				items
    			}
            }
        });
    }

    handleRemoveAll(event) {
        event && event.preventDefault();
        const self = this;
        const { selectedPriceSource } = this.props.state.user;
		let agreementNumber = '';
		if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
			agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
		}
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items: [{
                        item: '',
                        itemError: '',
                        itemType: 'M',
                        quantity: "1",
                        price: '',
                        productDetails: null,
                        agreementNumber,
                        quantityError: false,
                        agreementNumberError: false
                    }]
                }
            }
        });
    }

    handleAddAccessories(accessories) {
        const self = this;
        let { items } = self.state.createPackageForm.params;
        const needToAddAccessories = [];
        accessories.forEach(item => {
            // If selected accessory is already added then we have to ignore that accessory
            if (!items.find(itm => itm.item === item.item)) {
                needToAddAccessories.push({
                    serviceType: 'A',
                    serviceId: item.item,
    				price: item.price,
    				serviceName: item.itemDescription,
    				quantity: item.quantity,
    				extendedPrice: item.price,
                });
            } else {
                // if that item is already there then checked it
                items.forEach(itm => {
                    if (itm.item === item.item) {
                        itm.checked = true;
                    }
                });
            }
        });
        let relatedServices = items[self.state.selectedSKUIndex].relatedServices || [];
        const existingServices = relatedServices.filter(item => item.serviceType === 'S');
        const existingAccessories = relatedServices.filter(item => item.serviceType === 'A');
        items[self.state.selectedSKUIndex].relatedServices = existingAccessories.concat(needToAddAccessories).concat(existingServices);
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items
                }
            }
        });
    }

    handleAddNewProduct(event) {
        event.preventDefault();
        const self = this;
        const { items } = self.state.createPackageForm.params;
        const { selectedPriceSource } = this.props.state.user;
        let agreementNumber = '';
        if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
            agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
        }
        items.push({
            item: '',
            itemError: '',
            itemType: 'M',
            quantity: "1",
            price: '',
            productDetails: null,
            agreementNumber,
            quantityError: false,
            agreementNumberError: false,
            whenAdded: 'new'
        });
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items
                }
            }
        });
    }

    handleDelete(indx, subIndex, event) {
		event.preventDefault();
		const self = this;
		const items = JSON.parse(JSON.stringify(self.state.createPackageForm.params.items));
		items.forEach((item, index) => {
			if(index === indx) {
                if (subIndex !== null) {
                    item.relatedServices = item.relatedServices.filter((itm, ind) => ind !== subIndex);
                } else {
	                item.isDelete = true;
                }
			}
		});
		self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items
                }
            }
		});
	}

    handleCallBackAfterAddedNewAddress(data, addressCreated) {
		const self = this,
			shippingAddressList = self.state.shippingAddressList;
        if(!shippingAddressList.find(item => item.ADDRESS1 === data.address1 && item.CITY === data.city && item.STATE === data.state && item.POSTALCODE.indexOf(data.zipCode) === 0)) {
			shippingAddressList.push({
				FIRSTNAME: data.firstName,
				LASTNAME: data.lastName,
				ADDRESS1: data.address1,
				ADDRESS2: data.address2,
				ADDRESS3: data.address3,
				ADDRESS4: data.address4,
				CITY: data.city,
				COUNTY: data.county,
				STATE: data.state,
				POSTALCODE: data.zipCode,
				SITE_USE_ID: data.addressId,
                isNewAddressAdded: true
			});
		}

		self.setState({
			showAddShippingAddressOverlayDialog: false,
			shippingAddressList,
			createPackageForm: {
				...self.state.createPackageForm,
				params: {
					...self.state.createPackageForm.params,
					shippingAddress: {
                        ...self.state.createPackageForm.params.shippingAddress,
                        address1: data.address1,
                        address2: data.address2,
                        address3: data.address3,
                        address4: data.address4,
                        city: data.city,
                        state: data.state,
                        zip: data.zipCode,
                        phone: '',
                        addressId: data.addressId,
                        SITEID: '',
                        firstName: data.firstName,
						lastName: data.lastName,
                        newAddress : true
                    }
				}
			}
		});
	}

    getElementOffset(elementId) {
		var bodyRect = document.body.getBoundingClientRect(),
			el2 = document.getElementById(elementId).getBoundingClientRect(),
			offset   = el2.top - bodyRect.top;
		return offset;
	}

    handleSubmit(event) {
        event.preventDefault();
        const self = this,
            { params, errors } = self.state.createPackageForm;
        const { selectedAddress } = self.props.state.user;
        const selectedAddressValue = JSON.parse(selectedAddress);
        let formError = false;
        if(params && selectedAddressValue.PURPOSE === 'SOLD_TO' && !params.shippingAddress.newAddress === true){
            errors.shippingAddressError = 'Error' 
             self.state.createPackageForm.params.shippingAddress = null;
        }

        for(var key in errors) {
            if(params[key.replace("Error","")] === "" || params[key.replace("Error","")] === null) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }
        params.items.forEach((item, index) => {
			if(!item.isDelete) {
                if(!item.item) {
	                item.itemError = true;
	                formError = true;
	            }
                if(!item.quantity || item.quantity < 0) {
	                item.quantityError = true;
	                formError = true;
	            }
	            if(item.productDetails && item.productDetails.status === false) {
	                formError = true;
	            }
				if(item.productDetails && (!item.productDetails.pricingData || item.productDetails.pricingData.length === 0)) {
	                formError = true;
	            }
                if(item.relatedServices) {
    				item.relatedServices.map((itm, indx) => {
    					itm.quantityError = (itm.quantity === '' || itm.quantity === 0)?'error':''
    					if(itm.quantity === '') {
    						formError = true;
    						window.scrollTo(0, self.getElementOffset("quantity"+index));
    					}
    					return null;
    				})
    			}
				// skuList.push({sku: item.item, itemType: 'M'});
			}
        });

        let errorMessage = '';
        if (params.whichTypeOfCreate === 'pickModels') {
            const items = JSON.parse(JSON.stringify(params.items)).filter(item => item.checked);
            if (items.length === 0) {
                errorMessage = 'Please select at least one item to create package.';
                formError = true;
                window.scrollTo(0, 0);
            }
        }
        if(params.shippingAddress === null){
            errorMessage = 'Please add shipping address.';
                formError = true;
                window.scrollTo(0, 0);
        }
        if(params.shippingAddress && params.shippingAddress.newAddress  && params.shippingAddress.newAddress === true){
            errorMessage = '';
            formError = false;
        }

        if (!params.poNumber) {
            window.scrollTo(0, 0);
        }
        self.setState({
            createPackageForm: {
    			params,
    			errors
            },
            errorMessage,
		}, () => {
            if(!formError) {
                const { userDetails, selectedPriceSource } = self.props.state.user;
                let items = JSON.parse(JSON.stringify(params.items)).filter((item) => !item.isDelete);
                if (params.whichTypeOfCreate === 'pickModels') {
                    items = items.filter(item => item.checked);
                }
                const payload = {
                    ...params,
                    items,
                    poNumber: params.poNumber.toUpperCase(),
                    createdById: userDetails.sso,
                    createdBy: userDetails.firstName + " " + userDetails.lastName,
                    email: userDetails.email,
                    accountNumber: self.props.getSelectedAccountNumber(),
                    deliveryMethod: params.deliveryMethod,
                    agreementNumber: selectedPriceSource.AGREEMENT_NUMBER
                };
                let imagePayload = {};
                params.items.length>0 && params.items.forEach((product)=>{
                    imagePayload[product.item] = product.productDetails? product.productDetails.imagePath:product.imagePath
                });

                let itemsDetails=payload.items
                let filteredItemPrice= itemsDetails.map(function(item){
                    return item['price'];
                })  
                                                
               function  getItemPrice(price)
                {                      
                    for(let i=0;i<price.length;i++)
                    {
                        if(price[i]=='')
                        {
                            return true;
                        }                
                    }
                    return false;                  
                }

                let itemPriceStatus=getItemPrice(filteredItemPrice); 
                if(itemPriceStatus==false)
                {
                    self.props.createNewOrder(payload, "requestType=createPackageOrder", false, response => {                     
                       
                            if(response.status && response.responseObject) {
                                self.props.saveCreatedPackageDetails({...response.responseObject,...imagePayload});              
                                browserHistory.push('package/create/confirmation')
                               
                            }                          
                        });
                }
                else{
                    self.setState({
                        errorMessage: 'Please enter valid product'
                    });  
                }
                
            }
        });
    }

    handleAddNewAddress(event) {
		event.preventDefault();
		this.handleDialog("AddShippingAddressOverlayDialog", true);
		this.props.showAddressVerificationDialog(false);
	}

    getShippingAddressState() {
		const self = this;
		const { createPackageForm } = self.state;
		const { shippingAddress } = createPackageForm.params;
		return shippingAddress.state;
	}

    showAddAccessories(sku, itemDescription, index, event) {
        event.preventDefault();
        this.setState({
            accessoriesSku: sku,
            selectedSKUIndex: index,
            itemDescription: itemDescription
        }, () => {
            this.handleDialog('AddAccessoriesDialog', true);
        });
    }

    getShippingAddressZipCode() {
        const self = this;
        const { createPackageForm } = self.state;
        const { shippingAddress } = createPackageForm.params;
        return shippingAddress.zip.split("-")[0];
    }

    checkIfStateIsAk() {
		const self = this;
		const { shippingAddress } = self.state.createPackageForm.params;
		let flag = false;
		if(shippingAddress && shippingAddress.state === 'AK') {
			flag = true;
		}
		return flag;
	}

    checkLocTypeAvailable(loctype) {
		const self = this;
		let shippingAddressDetail = _.find(self.props.state.user.shippingAddressDetailsListWithZipCode, {zipCode: self.getShippingAddressZipCode()});
		let data = shippingAddressDetail && _.find(shippingAddressDetail.details, ["loctype", loctype]);
		if(data && data.agentid && data.agentid !== "NA") {
			return true;
		} else {
			return false;
		}
	}

    handleAddServices(index, item, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			selectedSKU: item.item,
			selectedSKUIndex: index,
            selectedSKUAccessories: (item.relatedServices || []).filter(item => item.serviceType === 'A')
		}, () => {
				// make service call to get warehouseCode and then make pricing service call
				self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, 'sds_loc', resp => {
					if(self.checkIfStateIsAk()) {
						resp = {
							agentid: "SEA",
							dockcity: "SEATTLE"
						}
					}
					if(resp && resp.agentid) {
                        const record = _.find(self.props.state.order.orderableServices, {sku: item, zipCode: self.getShippingAddressZipCode()});
                         if(record) {
                         self.manageAvailableServices(self.props.state.order.orderableServices, item, self.getShippingAddressZipCode());
                        } else{
                            const itemnumbers = self.state.createPackageForm.params.items.filter(item => item.itemType === 'M' && item.item === self.state.selectedSKU).map(item => item.item);
						// Get all orderable services list
						self.props.getOrderableServices({
							OrderabilityRequest: {
								inventoryorg: resp.agentid,
								zipcode: self.getShippingAddressZipCode(),
								shipmethod: self.state.createPackageForm.params.deliveryMethod,
								itemnumbers: _.uniq(itemnumbers)
							}
						}, "requestType=getOrderableServices", response => {
							if(response.status) {
								const orderableServices = JSON.parse(JSON.stringify(response));
								const { selectedAccount, selectedPriceSource } = self.props.state.user;
								const servicesPayload = [];
								const { shippingAddress } = self.state.createPackageForm.params;
                                const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
								response.responseObject && response.responseObject.OrderabilityResponse.orderability.forEach(item => {
									if(item.service.length === 4 && item.service.indexOf("M") === 0) {
										servicesPayload.push({
											pricingEffectiveDate: moment().format('YYYYMMDD'),
											accountNumber,
							                state: shippingAddress.state,
											whse: resp.agentid,
							                zone: resp.sdsApZone,
											salesAgreementNumber,
											itemNumber: item.service
										});
									}
								});
                                self.setState({
									requiredPayloadForServicePricing: {
										pricingEffectiveDate: moment().format('YYYYMMDD'),
										accountNumber,
										state: shippingAddress.state,
										whse: resp.agentid,
										zone: resp.sdsApZone,
                                        postalCode: self.getShippingAddressZipCode(),
										country: shippingAddress.country ? shippingAddress.country : "US",
										salesAgreementNumber
									}
								}, () => {
    								if(servicesPayload.length > 0) {
    									// Get all orderable services prices list
    									self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
    										if(resp.status) {
    											// let orderableServices = self.props.state.order.orderableServices;
    											// TO DO : Temporary conversion from json string to json
    											resp.responseObject = JSON.parse(resp.responseObject);
    											const orderableServicesTemp = [];
    											orderableServices.responseObject.OrderabilityResponse.orderability.forEach(item => {
    												let record = _.find(resp.responseObject.items, {itemNumber: item.service});
    												if(record && (record.unitPrice || record.unitPrice === 0)) {
    													orderableServicesTemp.push({
    														...item,
    														servicePrice: record.unitPrice,
    														serviceDescription: item.description,
    													});
    												}
    											});
    											let finalData = [];
                                                self.state.createPackageForm.params.items.forEach(itm => {
    												if (itm.item === self.state.selectedSKU) {
    													finalData.push({
    														sku: itm.item,
    														services: _.filter(orderableServicesTemp, {itemnumber: itm.item})
    													});
    												}
    											});
    											let existingOrderableServices = self.props.state.order.orderableServices;
    											existingOrderableServices = existingOrderableServices.filter(it => it.sku !== self.state.selectedSKU);
    											existingOrderableServices = existingOrderableServices.concat(finalData);
    											self.props.saveOrderableServices(existingOrderableServices);
    											self.manageAvailableServices(finalData, self.state.selectedSKU, self.state.selectedSKUIndex);
    										} else {
    											browserHistory.push("/error");
    										}
    									})
    								} else {
    									let finalData = [];
    									self.state.createPackageForm.params.items.forEach(itm => {
    										finalData.push({
    											sku: itm.item,
    											services: []
    										})
    									})
    									self.manageAvailableServices(finalData, self.state.selectedSKU, self.state.selectedSKUIndex);
    								}
                                });
							} else {
								browserHistory.push("/error");
							}
						});
                        }
					}
				}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber());
			
		});
	}

	manageAvailableServices(finalData, sku) {
		const self = this;
		const availableServices = _.find(finalData, {sku});
		self.setState({
			availableServices: availableServices && availableServices.services
		}, () => {
			self.handleDialog("AddServicesOverlayDialog", true, null);
		})
	}

    handleSelectedServices(serviceData, skuList, selectedSKUIndex, uncrateInd) {
		var self = this,
			items = self.state.createPackageForm.params.items;
	    items.map((item, index) => {
			if(index === selectedSKUIndex) {
                item.relatedServices = self.state.selectedSKUAccessories;
                if(skuList) {
                    skuList = skuList.filter(itm => itm.serviceType !== 'A');
                    skuList.forEach(item => {
                        item.serviceType = 'S';
                    });
                    item.relatedServices = item.relatedServices.concat(skuList);
                }
				// If user has changed uncratedInd then we have to keep it as it is.
				// else change it as per function param named uncrateInd
				// if (item.originalUncrateInd === item.uncrateInd) {
					item.uncrateInd = uncrateInd;
				// }
				// const bagItems = _.filter(item.relatedServices, {type: 'BAG'});
				// // if all related services are not of type BAG
				// if(bagItems.length !== item.relatedServices.length) {
				// 	item.uncrateInd = item.relatedServices && item.relatedServices.length > 0 ? 'Y' : 'N';
				// } else { // else all items are BAG items
				// 	item.uncrateInd = 'N';
				// }
			}
			return null;
		})
		self.setState({
			showAddServicesOverlayDialog: false,
			createPackageForm: {
				...self.state.createPackageForm,
				params: {
					...self.state.createPackageForm.params,
					items: items
				}
			}
		});
	}

    // handleShowServiceDescription(serviceDetails, event) {
	// 	event.preventDefault();
	// 	var self = this;
	// 	self.setState({
	// 		genericDialogHeading: "Service",
    //         genericDialogText: serviceDetails.serviceId + " - " + serviceDetails.serviceName,
    //         modalButtons: 'ok'
	// 	}, () => {
	// 		self.handleDialog("GenericOverlayDialog", true);
	// 	});
	// }

    handleChangeQuantityService(index, serviceId, event) {
		const self = this;
		let items = self.state.createPackageForm.params.items;
		let value = event.target.value;
		value = value === "0" ? 1 : value;
		items.forEach((item, indx) => {
			if(index === indx) {
				item.relatedServices.forEach((itm, ind) => {
					if(itm.serviceId === serviceId) {
						itm.quantity = value
						itm.quantityError = value === ''?'error':''
					}
				})
			}
		});
		self.setState({
			createPackageForm: {
				...self.state.createPackageForm,
				params: {
					...self.state.createPackageForm.params,
					items
				}
			}
		});
	}

    fetchQuoteModels() {
        const self = this;
        const { selectedAccount, selectedPriceSource } = self.props.state.user;
        const accountReference = selectedPriceSource['Account Reference'];
        const quote = accountReference.split(' ')[1];
        const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
        self.props.getModelsBySalesAgreement(`requestType=getQuoteModels&accountNumber=${accountNumber}&salesAgreement=${salesAgreementNumber}`, (response) => {
            if(response.status) {
                if (response.responseObject && response.responseObject.length) {
                    response.responseObject = response.responseObject.map(item=> item.item_number);
                    response.responseObject = _.uniq(response.responseObject);
                    const selectedServices = response.responseObject.filter(item => item.trim() && item.length === 4 && item.indexOf("M") === 0).sort();
                    let itemsOrAccessories = response.responseObject.filter(item => item.trim() && item.length !== 4 && item.indexOf("M") !== 0).sort();
                    self.setState({
                        getItemsCallCompleted: itemsOrAccessories.length === 0,
                        pimDataCallCompleted: selectedServices.length === 0,
                        servicesPricingCompleted: selectedServices.length === 0,
                        selectedServices,
                    }, () => {
                        if (selectedServices.length > 0) {
                            // Make pim data service call for getting description for services
                            self.props.getPimDataInBatches(selectedServices, 100, responseObject => {
                                self.setState({
            						pimData: responseObject,
                                    pimDataCallCompleted: true,
            					}, () => {
            						self.checkAllCallCompleted();
            					});
                            });
                            self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, 'sds_loc', resp => {
                                if(self.checkIfStateIsAk()) {
                                    resp = {
                                        agentid: "SEA",
                                        dockcity: "SEATTLE"
                                    }
                                }
                                if (resp.agentid) {
                                    const servicesPayload = [];
                                    const { shippingAddress } = self.state.createPackageForm.params;
                                    const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
                                    selectedServices.forEach(item => {
                                        servicesPayload.push({
                                            pricingEffectiveDate: moment().format('YYYYMMDD'),
                                            accountNumber,
                                            state: shippingAddress.state,
                                            whse: resp.agentid,
                                            zone: resp.sdsApZone,
                                            salesAgreementNumber,
                                            itemNumber: item
                                        });
                                    });
                                    self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
                                        if(resp.status) {
                                            // let orderableServices = self.props.state.order.orderableServices;
                                            // TO DO : Temporary conversion from json string to json
                                            resp.responseObject = JSON.parse(resp.responseObject);
                                            self.setState({
                                                servicePricingData: resp.responseObject.items,
                                                servicesPricingCompleted: true,
                                            }, () => {
                                                self.checkAllCallCompleted();
                                            });
                                        }
                                    });
                                }
                            });
                        } else {
                            self.checkAllCallCompleted();
                        }
                        if (itemsOrAccessories.length > 0) {
                            itemsOrAccessories = _.chunk(itemsOrAccessories, 10);
                            const promises = [];
                            self.props.ajaxRequestInitiated();
                            itemsOrAccessories.forEach(item => {
                                promises.push(
                                    sendRequest(
                                        productAPIUrl,
                                        product.getKeyWordSuggession.path,
                                        '',
                                        product.getKeyWordSuggession.method,
                                        `requestType=getItems&keyword=${item.join(' ')}&accountNumber=${self.props.getSelectedAccountNumber()}&zipCode=${self.props.getZipCode()}&page=search`
                                    )
                                );
                            });
                            Promise.all(promises).then((responses) => {
                                // logic to combine all responses and then run call back
                                let responseObject = [];
                                let response = {};
                                if(responses.length > 0) {
                                    responses.forEach(resp => {
                                        responseObject = responseObject.concat(resp.responseObject);
                                    });
                                    response = {
                                        ...responses[0],
                                        responseObject
                                    }
                                } else {
                                    response.responseObject = [];
                                }
                                self.props.ajaxRequestCompleted();

                                let selectedItems = [];
                                response.responseObject.forEach(itm => {
                                    selectedItems.push({
                                        ...itm,
                                        item: itm.sku,
                                        itemDescription: itm.description,
                                    });
                                });
                                selectedItems = _.orderBy(selectedItems, ['item'], ['asc']);
                                const { selectedPriceSource } = self.props.state.user,
                        			skuList = selectedItems.map(item => item.sku);
                                // now for quick order page first make product pricing service call to calculate total cost
            					const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
            					self.props.checkPricesForSearchResult({
            						account_number: self.props.getSelectedAccountNumber(),
            						pricing_effective_date: pricingEffectiveDate,
            						sa_number: selectedPriceSource.AGREEMENT_NUMBER,
            						item_numbers: skuList
            					}, true, false, response => {
            						if(response.status) {
            							response = self.props.processPricingResponse(response);
                                        const items = [];
                                        selectedItems.forEach((item) => {
                                            let price = 0;
            								price = _.find(response.responseObject.items, { item_number: item.sku });
            								if(price && price.records && price.records.length > 0)
            									price = price.records[0].adjusted_unit_price || price.records[0].unit_price
            								else {
            									price = 0;
            								}
                                            if(price) {
                                                items.push({
                                                    agreementNumber: selectedPriceSource.AGREEMENT_NUMBER,
                                                    item: item.sku,
                                                    itemDescription: item.description,
                                                    itemType: item.itemType,
                                                    price,
                                                    quantity: "1",
                                                    checked: false,
                                                    imagePath: item.imagePath
                                                });
                                            }
                                        });
                                        self.setState({
                                            selectedItems: items,
                                            getItemsCallCompleted: true,
                                        }, () => {
                                            self.checkAllCallCompleted();
                                        });
                                    }
                                });
                            });
                        } else {
                            self.checkAllCallCompleted();
                        }
                    });
                } else {
                    self.setState({
                        genericDialogHeading: 'Quote',
                        genericDialogText: 'No models found in the quote',
                        modalButtons: 'ok',
                    }, () => {
                        self.handleDialog('GenericOverlayDialog', true);
                    });
                }
            }
        });
    }

    checkAllCallCompleted() {
        const self = this;
        const {
            getItemsCallCompleted,
            pimDataCallCompleted,
            servicesPricingCompleted,
            selectedItems,
            selectedServices,
            servicePricingData,
            pimData
        } = self.state;
        if (getItemsCallCompleted && pimDataCallCompleted && servicesPricingCompleted) {
            const allItems = selectedItems;
            const { selectedPriceSource } = self.props.state.user;
            selectedServices.forEach((service) => {
                const pricingData = _.find(servicePricingData, {itemNumber: service});
                const pimItemData = _.find(pimData, {item_number: service});
                if (pricingData) {
                    allItems.push({
                        agreementNumber: selectedPriceSource.AGREEMENT_NUMBER,
                        item: service,
                        itemDescription: pimItemData.item_description,
                        itemType: 'S',
                        price: pricingData.unitPrice,
                        quantity: '1',
                    });
                }
            });
            // Append services if any
            self.setState({
                createPackageForm: {
                    ...self.state.createPackageForm,
                    params: {
                        ...self.state.createPackageForm.params,
                        items: allItems,
                    }
                }
            });
        }
    }

    handleSelectItem(indx, e) {
		const self = this;
        const { items } = self.state.createPackageForm.params;
        items[indx].checked = e.target.checked;
		self.setState({
            errorMessage: '',
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items
                }
            }
		});
	}

    render() {
        const self = this;
        const requiredPayloadForServicePricing = self.state.requiredPayloadForServicePricing;
        const {
            createPackageForm: {
                params,
                errors
            },
            shippingAddressList,
            errorMessage
        } = self.state;
        const {
            items,
            poNumber,
            whichTypeOfCreate,
        } = params;
        const {
            selectedPriceSource,
        } = self.props.state.user;
        const shippingAddress = params.shippingAddress;
        const quoteType = self.props.getAttributeBySalesAgreement(selectedPriceSource.AGREEMENT_NUMBER, 'Quote Type');
       
        return (
            <div>
                <h1 className="pageTitle">CREATE PACKAGE</h1>
                <p className="red bold">{errorMessage}</p>
                <form name="packagecreateform" onSubmit={this.handleSubmit.bind(this)}>
                    <div className="fullCell">
                        <p>You are creating a package for: &nbsp; <span className="bold">{selectedPriceSource && selectedPriceSource.AGREEMENT_NAME}</span></p>
                    </div>
                    {(quoteType === 'Q' || quoteType === 'M' || quoteType === 'U') && <div id="radioSection" className="fullCell">
                        <p>
                            <span className="bold">Select how you'd like to add models to your packages. </span>
                        </p>
                        <p>
                            <input type="radio" name="whichTypeOfCreate" id="iWillEnter" onClick={this.onChangeUpdateParam.bind(this)} value="iWillEnter" checked={whichTypeOfCreate === 'iWillEnter'} />
                            <label htmlFor="iWillEnter">I'll enter my own model numbers</label>
                        </p>
                        <p>
                            <input style={{marginTop: '0px'}} type="radio" name="whichTypeOfCreate" id="pickModels" onClick={this.onChangeUpdateParam.bind(this)} value="pickModels" checked={whichTypeOfCreate === 'pickModels'} />
                            <label htmlFor="pickModels">Pick models from sales agreement (quote)</label>
                        </p>
                    </div>}
                    <div className={`fullCell ${errors.poNumberError}`}>
                        <div className="pkgbold">Package Name: </div> &nbsp; <input maxLength={50} onChange={this.onChangeUpdateParam.bind(this)} type="text" name="poNumber" size={50} value={poNumber} /> &nbsp; <span> Maximum 50 characters </span>
                    </div>
                    <div className="fullCell">
                        <table id="pckgaddrtbl" cellPadding={0} cellSpacing={0} border={0} width="100%">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="pkgbold">Shipping Address:</div>
                                    </td>
                                    <div className={`fullCell ${errors.poNumberError}`}>
                                        <td>
                                            <select id="packageSelectNamesId" style={{width: '41%'}} value={params.shippingAddress ? params.shippingAddress.address1 : ''} onChange={this.onChangeShippingAddress.bind(this)} name="shippingAddress">
                                                {shippingAddressList.map((itm, ind) => {
                                                    const list = [];
                                                    if(itm.ADDRESS1) list.push(itm.ADDRESS1);
                                                    if(itm.CITY) list.push(itm.CITY);
                                                    if(itm.STATE) list.push(itm.STATE);
                                                    if(itm.LOCATION) list.push(itm.LOCATION);
                                                    return <option key={ind} value={itm.ADDRESS1}>
                                                        {list.join(', ')}
                                                    </option>
                                                })}
                                            </select>
                                            &nbsp;
                                            <div><p> Services available will be determined by this address</p></div>    
                                        </td>
                                    </div>
                                    </tr>
                                    <tr>
                                        <td />
                                        <td>
                                            {shippingAddress && (shippingAddressList &&shippingAddressList.length > 0) && <p className="shippingAddress">
    											{shippingAddress.address1 && shippingAddress.address1.trim()}
    											{shippingAddress.address1 && shippingAddress.address1.trim() !== ""?<br/>:null}
    											{shippingAddress.address2 && shippingAddress.address2.trim()}
    											{shippingAddress.address2 && shippingAddress.address2.trim() !== ""?<br/>:null}
    											{shippingAddress.city && `${shippingAddress.city.trim()},`} {shippingAddress.state && shippingAddress.state.trim()} {shippingAddress.zip && shippingAddress.zip.trim()}
    										</p>}
                                            {this.props.showAddNewAddressLink
                                                ?<p><a href="" onClick={this.handleAddNewAddress.bind(this)}>+ Add New Shipping Address</a></p>
                                                :null
                                            }
                                        </td>
                                    </tr>
                            </tbody>
                        </table>
                    </div>
                    <table id="createTable" className="dataTableType2 createOrderTableB milktoast2" style={{width: '100%'}}>
                        <thead>
                            <tr>
                                <th>
                                    {whichTypeOfCreate === 'iWillEnter'
                                        ? <a href="#" onClick={this.handleRemoveAll.bind(this)}> Remove<br />All</a>
                                        : "Add to Package"
                                    }
                                </th>
                                <th>Product</th>
                                <th>Description</th>
                                <th>Price</th>
                                <th>Quantity</th>
                                <th />
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => {
                                if (item.isDelete) return null;
                                return [<tr key={index}>
                                    <td style={{width: '5%'}}>
                                        {whichTypeOfCreate === 'iWillEnter'
                                            ? <a href="" onClick={this.handleDelete.bind(this, index, null)} style={{textDecoration: 'none'}}>X</a>
                                            : <input type="checkbox" name={"checked"+index} value="1" id={"checked"+index} onClick={this.handleSelectItem.bind(this, index)} checked={item.checked} />
                                        }
                                    </td>
                                    {((item.productDetails && item.productDetails.status &&
                                        (item.productDetails.pricingData && item.productDetails.pricingData.length > 0)) || (whichTypeOfCreate === 'pickModels' && !item.whenAdded))
                                        ? <td style={{width: '25%'}}>{item.item}</td>
                                        : <td
                                            style={{width: '25%'}}
                                            className={(
                                                (item.productDetails && item.productDetails.status === false) && item.productDetails===null ||
                                                (item.productDetails &&
                                                    (!item.productDetails.pricingData || item.productDetails.pricingData.length === 0)
                                                ) ||
                                                item.itemError
                                            )?"error":""}>
                                            <AccountNumberAutoSuggests
                                               checkAvailabilityAndOrderability={this.props.checkAvailabilityAndOrderability}
                                               selectedAddressParams={null}
                                               getShippingAddressesDetails={this.props.getShippingAddressesDetails}
                                               value={item.item}
                                               setChangeMethod={(method, input) => this.setChangeMethod[index] = {method, input} }
                                               selectedPriceSource={item.agreementNumber}
                                               updateQuickOrderState={this.updateQuickOrderState.bind(this)}
                                               onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)}
                                               itemIndex={index}
                                               zipCode={this.props.getZipCode()}
                                               itemType={item.itemType}
                                               isImportedFromFile={false}
                                               isAddressChanged={item.isAddressChanged}
                                               width='auto'
                                               getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
                                           />
                                           {(item.productDetails && item.productDetails.status === false) || (item.productDetails)
                                               ?<span className="quickOrderTableRowError">You must enter a valid full or partial product number.</span>
                                               :null
                                           }
                                       </td>
                                    }
                                    <td style={{width: '25%'}}>
                                        <p>
                                            {item.itemDescription}
                                        </p>
                                    </td>
                                    <td style={{width: '5%'}}>
                                        <p>{self.props.formatMoney(item.price, 0, ".", ",", false, "$")}</p>
                                    </td>
                                    <td style={{width: '5%'}}>
                                        <div>
                                            <input className={item.quantityError?"error":""} style={{textAlign: 'center'}} type="text" name="quantity" size={3} onChange={this.onChangeUpdateItem.bind(this, index)} value={item.quantity} />
                                        </div>
                                    </td>
                                    <td style={{width: '20%'}}>
                                        {((item.productDetails && item.productDetails.status) || (whichTypeOfCreate === 'pickModels' && item.itemType === 'M')) && <p className="addAccessories">
                                            <a href="" onClick={this.showAddAccessories.bind(this, item.item, item.productDetails && item.productDetails.description, index)} >+&nbsp;Accessories</a>
                                        </p>}
                                    </td>
                                    <td style={{width: '15%'}}>
                                        {params.deliveryMethod === 'SDS Delivery' && ((item.productDetails && item.productDetails.status) || (whichTypeOfCreate === 'pickModels' && item.itemType === 'M')) &&
                                            <p>
                                                <a onClick={this.handleAddServices.bind(this, index, item)} href="">
                                                    + Add Services
                                                </a>
                                            </p>
                                        }
                                    </td>
                                </tr>,
                                item.relatedServices?
                                    item.relatedServices.map((itm, ind) => {
                                        if(itm.type === "BAG") return null;
                                        return <tr key={ind}>
                                            <td style={{width: '5%'}}>
                                                {whichTypeOfCreate === 'iWillEnter'
                                                    && <a href="" onClick={this.handleDelete.bind(this, index, ind)} style={{textDecoration: 'none'}}>X</a>
                                                }
                                            </td>
                                            <td style={{width: '25%'}}>
                                                &nbsp; &nbsp; {itm.serviceId}
                                            </td>
                                            <td style={{width: '25%'}}>{itm.serviceName}</td>
                                            <td style={{width: '5%'}}>{this.props.formatMoney(itm.price, 0, ".", ",", false, "$")}</td>
                                            <td style={{width: '5%'}}>
                                                <input
                                                    type="text"
                                                    id={"servicequantity"+ind}
                                                    className={`itemQuantity ${itm.quantityError}`}
                                                    onKeyPress={this.props.acceptNumbersOnly}
                                                    onPaste={this.props.doNothing}
                                                    value={itm.quantity}
                                                    onChange={this.handleChangeQuantityService.bind(this, index, itm.serviceId)}
                                                    defaultValue={item.quantity}
                                                    size={1}
                                                />
                                            </td>
                                            <td style={{width: '20%'}} />
                                            <td style={{width: '15%'}} />
                                        </tr>
                                    }):
                                null
                            ]})}
                        </tbody>
                    </table>
                    <br />
                    <div id="createpckbtn">
                        <p className="floatLeft addNewPageParagraph">
                            <a className="bold noUnderline uppercase" href="" onClick={this.handleAddNewProduct.bind(this)}>+ ADD ANOTHER PRODUCT</a>
                        </p>
                        <p className="floatRight">
                            <input type="submit" className="blueButton" value="CREATE PACKAGE" />
                        </p>
                    </div>
                </form>
                {this.state.showAddShippingAddressOverlayDialog?<AddShippingAddressOverlayDialog showOtherFieldsInAddShippingAddress={this.props.showOtherFieldsInAddShippingAddress} handleDialog={this.handleDialog} existingAddresses={this.state.shippingAddressList} handleCallBackAfterAddedNewAddress={this.handleCallBackAfterAddedNewAddress.bind(this)} showDialog={true} />:null }
                {this.state.showAddAccessoriesDialog
		            ? <AddAccessoriesDialog
						checkAvailabilityGeneric={this.props.checkAvailabilityGeneric}
						getShippingAddressesDetails={this.props.getShippingAddressesDetails}
						makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices}
						accessoriesSku={this.state.accessoriesSku}
                        handleAddAccessories={this.handleAddAccessories}
						itemDescription={this.state.itemDescription}
						handleDialog={this.handleDialog.bind(this)}
						showDialog={true}
						getZipCode={this.props.getZipCode}
						
						getLocalStorageVar={this.props.getLocalStorageVar}
						manipulateProductSpecsData={this.props.manipulateProductSpecsData}
						isPricingAccess={this.props.isResponsibilityExists("Price")}
						fireGTMTag={this.props.fireGTMTag}
						formatMoney={this.props.formatMoney}
						getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
					/>
		            : null
		        }
                {this.state.showAddServicesOverlayDialog && this.state.availableServices?
					<AddServicesOverlayDialog
						availableServices={this.state.availableServices}
						resetSelectedSKU={this.resetSelectedSKU}
						handleSelectedServices={this.handleSelectedServices.bind(this)}
						handleDialog={this.handleDialog}
						itemLevelDisableUncrateDropdown={false}
						selectedSKU={this.state.selectedSKU}
						selectedSKUIndex={this.state.selectedSKUIndex}
						formatAmount2Decimal={this.props.formatAmount2Decimal}
						items={this.state.createPackageForm.params.items}
						getPIMItemInfo={this.props.getPIMItemInfo}
						showDialog={true}
                        requiredPayloadForServicePricing={requiredPayloadForServicePricing}
					/>
				:null }
                {this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
    showAddressVerificationDialog: (flag) => dispatch(showAddressVerificationDialog(flag)),
    saveCreatedPackageDetails: (data) => dispatch(saveCreatedPackageDetails(data)),
    getOrderableServices: (payload, params, response) => dispatch(getOrderableServices(payload, params,response)),
    checkServicePrices: (payload, params, response) => dispatch(checkServicePrices(payload, params, response)),
    getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
    getModelsBySalesAgreement: (payload, callback) => dispatch(getModelsBySalesAgreement(payload, callback)),
    createNewOrder: (payload, params, useBootApi, response) => dispatch(createNewOrder(payload, params, useBootApi, response)),
	ajaxRequestInitiated: (data) => dispatch(ajaxRequestInitiated(data)),
	ajaxRequestCompleted: (data) => dispatch(ajaxRequestCompleted(data)),
    saveOrderableServices: (data) => dispatch(saveOrderableServices(data)),
    checkPricesForSearchResult: (data, showLoader, saveToStore, callback) => dispatch(checkPricesForSearchResult(data, showLoader, saveToStore, callback)),
});

CreatePackage = connect(mapStateToProps, mapDispatchToProps)(CreatePackage);
export default CreatePackage;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Packages/createPackage.js